export default "__VITE_ASSET__CLN_WPZu__"